<div class="flex flex-column align-items-center border-round-2xl surface-50 w-full">

    <!-- Botones de control -->
    <div class="flex gap-1 align-items-center w-full">
        <!-- <a pButton class="p-button-rounded p-button-sm p-button-help" (click)="deleteRecording()" >
            <i class="fas fa-trash"></i>
        </a> -->
        <a pButton icon="fas fa-trash" (click)="deleteRecording()"
                class="p-button-rounded p-button-text p-button-raised p-button-danger hover:bg-cyan-50"
                pTooltip="Descargar mensaje de voz" tooltipPosition="top" >
            </a>
        <div class="flex align-items-center gap-2" *ngIf="isRecording">
            <span class="record-indicator"></span>
        </div>
        <div  class="text-sm font-bold">
            {{ elapsedTime | date:'mm:ss':'UTC' }}
        </div>
        <!-- <div class="border-round-2xl w-5rem flex-1"> -->
            <canvas #canvas class="w-5rem h-2rem border-round-2xl flex-1" style="border: 1px solid #ccc; height: 1.2rem;">
            </canvas>
        <!-- </div> -->

        <!-- Pausar / Reanudar -->
        <a *ngIf="elapsedTime < limiteTime" pButton [icon]="isPaused ? 'fas fa-microphone' : 'fas fa-pause'" [pTooltip]="isPaused ? 'Reanudar grabación' : 'Pausar grabación'"
            tooltipPosition="top" 
            class="p-button-rounded p-button-raised p-button-warning" (click)="togglePauseResume()">
        </a>

        <!-- Detener -->
        <a pButton pTooltip="Enviar" tooltipPosition="top"  icon="fas fa-paper-plane" class="p-button-rounded p-button-sm" (click)="stop()">
        </a>
        
    </div>
</div>